import { util } from '../../shared/util';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { Transition } from '@uirouter/angular';
import { UIRouterModule } from '@uirouter/angular';
import { STATE_GLOBALPRODUCT, STATE_GLOBALPRODUCT_EDIT, STATE_GLOBALPRODUCT_EDIT_GENERAL, STATE_GLOBALPRODUCT_EDIT_IMAGES, STATE_GLOBALPRODUCT_EDIT_SPECS, STATE_GLOBALPRODUCT_NEW, STATE_GLOBALPRODUCT_NEW_GENERAL, STATE_GLOBALPRODUCT_VIEW } from '../../shared/app-states';
import { GlobalProductComponent } from './global-product.component';
import { GlobalProductService } from './global-product.service';
import { GlobalProductEditComponent } from './edit/global-product-edit.component';
import { GlobalProductEditGeneralComponent } from './edit/global-product-edit-general.component';
import { GlobalProductEditSpecsComponent } from './edit/global-product-edit-specs.component';
import { GlobalProductEditService } from './edit/global-product-edit.service';
import { GlobalProductEditImagesComponent } from './edit/global-product-edit-images.component';
import { SpecsNewPropertyDialogComponent } from './edit/specs-new-property-dialog.component';
import { GlobalProductDataService } from './global-product-data.service';
import { GlobalProductViewComponent } from './view/global-product-view.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

const states:GaStateDeclaration[] = [
  {
    name: STATE_GLOBALPRODUCT,
    url: '/globalproduct?product',
    abstract: true,
    component: GlobalProductComponent,
    resolve: [
      {
        token: 'productId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => {
          return Number(trans.params().product);
        }
      },
      {
        token: 'newProduct',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => {
          return trans.params().product === 'NEW' || util.isUndefined(trans.params().product);
        }
      }
    ]
  },


  {
    name: STATE_GLOBALPRODUCT_VIEW,
    url: '',
    component: GlobalProductViewComponent
  },


  {
    name: STATE_GLOBALPRODUCT_NEW,
    url: '',
    component: GlobalProductEditComponent,
    abstract: true
  },
  {
    name: STATE_GLOBALPRODUCT_NEW_GENERAL,
    url: '',
    component: GlobalProductEditGeneralComponent
  },


  {
    name: STATE_GLOBALPRODUCT_EDIT,
    url: '/edit',
    component: GlobalProductEditComponent,
    abstract: true,
    resolve: [{
      token: 'productId',
      deps: [ Transition ],
      resolveFn: (trans:Transition) => Number(trans.params().product)
    }]
  },
  {
    name: STATE_GLOBALPRODUCT_EDIT_GENERAL,
    url: '',
    component: GlobalProductEditGeneralComponent
  },
  {
    name: STATE_GLOBALPRODUCT_EDIT_IMAGES,
    url: '/images',
    component: GlobalProductEditImagesComponent,
    data: {
      noMaxWidth: true
    }
  },
  {
    name: STATE_GLOBALPRODUCT_EDIT_SPECS,
    url: '/specs',
    component: GlobalProductEditSpecsComponent
  }
];

@NgModule({
  declarations: [
    GlobalProductComponent,

    GlobalProductEditComponent,
    GlobalProductEditGeneralComponent,
    GlobalProductEditImagesComponent,
    GlobalProductEditSpecsComponent,
    SpecsNewPropertyDialogComponent,

    GlobalProductViewComponent
  ],
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ],
  providers: [
    GlobalProductService,
    GlobalProductEditService,
    GlobalProductDataService
  ]
})
export class GlobalProductModule {
}